export default "__VITE_PUBLIC_ASSET__50d747e6__"